import { useSubEvent } from '../../../../../../../hooks/SubEventProvider';
import { ResultType } from '@fastnorth/timer-api';
import { useSession } from '../../../../../../../hooks/SessionProvider';
import isAdmin from '../../../../../../../utils/isAdmin';
import displaySubmissionLink from '../utils/displaySubmissionLink';

type SubEventSettings = {
  isVirtualOpen?: boolean;
  onlyAllowRunkeeperResultSubmission?: boolean;
};

export const useShouldShowPostButton = (): boolean => {
  const { subEvent } = useSubEvent();
  const [{ session }] = useSession();
  const adminUser = isAdmin(session?.roles ?? undefined);

  const isVirtualRace = subEvent?.resultsType === ResultType.VIRTUAL;
  const isVirtualChallenge = subEvent?.resultsType === ResultType.VIRTUAL_CHALLENGE;

  if (!isVirtualRace && !isVirtualChallenge) {
    return false;
  }

  const settings = (subEvent?.settings ?? {}) as SubEventSettings;
  const isVirtualOpen =
    settings.isVirtualOpen ?? (subEvent as { isVirtualOpen?: boolean })?.isVirtualOpen;
  const onlyAllowRunkeeperResultSubmission = settings.onlyAllowRunkeeperResultSubmission ?? false;

  const shouldDisplay = displaySubmissionLink(
    isVirtualRace,
    Boolean(isVirtualOpen),
    onlyAllowRunkeeperResultSubmission
  );

  // Preserve admin override for Virtual Challenge visibility
  return shouldDisplay || (isVirtualChallenge && adminUser);
};
